import { apiClient, apiClientAuth } from "../http/httpClient";


export function UserApi(contentType = "application/json")
{
    const http = apiClient(contentType);
    const https = apiClientAuth(contentType);

    return {


        insert : (data) => http.post("/api/user", data),

        auth : (data) => http.post("/api/user/authentication", data), 


        getDataStat: () => http.get(`/api/user/stats/global`),


        findAll: () => https.get(`/api/user`),

        findCurUser: () => https.get(`/api/user/current`),

        findOne: () => https.get(`/api/user`),

       


        
        updateOne : (data) => https.put(`/api/user`, data),

        updateImage : (data) => https.put(`/api/user/image`, data),


        genPasswordToken : (email) => http.put("/api/user/password-updating", email), 

        updatePassword : (data) => http.put("/api/user/update-password", data), 


        activateAccount : (token) => http.put("/api/user/activate-account", token),

        blockAccount : (id) => https.put(`/api/user/${id}`)
        
  



      };
}

